export default __webpack_public_path__ + "static/media/Print.89f89f94.png";